import React from "react";
import SingleChat from "../co-components/SingleChat";

const Chatbox = ({
  userInfo,
  openChat,
  setOpenChat,
  getChatsAgain,
  setGetChatsAgain,
  windowWidth,
  notificationState,
  setNotificationState,
}) => {
  return (
    <>
      <SingleChat
        userInfo={userInfo}
        getChatsAgain={getChatsAgain}
        setGetChatsAgain={setGetChatsAgain}
        openChat={openChat}
        setOpenChat={setOpenChat}
        windowWidth={windowWidth}
        notificationState={notificationState}
        setNotificationState={setNotificationState}
      />
      {/* <GroupChat/> */}
    </>
  );
};

export default Chatbox;
